export const SITE_URL = 'https://uktakehomepaycalculator.com';

// Paths for the calculator tools, About and Blog are taken verbatim from the
// live WordPress site's page-sitemap.xml / post-sitemap.xml so existing
// backlinks, rankings and indexed URLs carry over unchanged.
export const ROUTES = {
  home: '/',
  calculator: '/gross-to-net-salary-calculator',
  monthly: '/monthly-take-home-pay-calculator',
  nhs: '/nhs-take-home-pay-calculator',
  nurse: '/nurse-take-home-pay-calculator',
  scottish: '/scottish-take-home-pay-calculator',
  ir35: '/ir35-take-home-pay-calculator',
  contractor: '/contractor-take-home-pay-calculator',
  umbrella: '/umbrella-take-home-pay-calculator',
  pension: '/salary-sacrifice-pension-calculator',
  reverse: '/reverse-take-home-pay-calculator',
  comparison: '/compare-salaries',
  taxcode: '/tax-code-calculator',
  selfEmployed: '/self-employed-tax-calculator',
  bonus: '/bonus-tax-calculator',
  hourlyToSalary: '/hourly-to-salary-calculator',
  proRata: '/pro-rata-salary-calculator',
  overtime: '/overtime-pay-calculator',
  minimumWage: '/minimum-wage-calculator',
  dividendTax: '/dividend-tax-calculator',
  mortgage: '/mortgage-repayment-calculator',
  stampDuty: '/stamp-duty-calculator',
  childBenefit: '/child-benefit-calculator',
  statutorySickPay: '/statutory-sick-pay-calculator',
  maternityPay: '/maternity-pay-calculator',
  teacherPay: '/teacher-take-home-pay-calculator',
  taxFreeChildcare: '/tax-free-childcare-calculator',
  blog: '/blog',
  about: '/about',
  writeForUs: '/write-for-us',
  contact: '/contact-us',
  privacy: '/privacy-policy',
  terms: '/terms-and-conditions',
  editorialPolicy: '/editorial-policy',
} as const;

export type RouteTab = keyof typeof ROUTES;

// Maps the legacy TabType identifiers used throughout the component tree to real URL paths.
export const TAB_TO_PATH: Record<string, string> = {
  home: ROUTES.home,
  calculator: ROUTES.calculator,
  monthly: ROUTES.monthly,
  nhs: ROUTES.nhs,
  nurse: ROUTES.nurse,
  scottish: ROUTES.scottish,
  ir35: ROUTES.ir35,
  contractor: ROUTES.contractor,
  umbrella: ROUTES.umbrella,
  pension: ROUTES.pension,
  reverse: ROUTES.reverse,
  comparison: ROUTES.comparison,
  taxcode: ROUTES.taxcode,
  selfEmployed: ROUTES.selfEmployed,
  bonus: ROUTES.bonus,
  hourlyToSalary: ROUTES.hourlyToSalary,
  proRata: ROUTES.proRata,
  overtime: ROUTES.overtime,
  minimumWage: ROUTES.minimumWage,
  dividendTax: ROUTES.dividendTax,
  mortgage: ROUTES.mortgage,
  stampDuty: ROUTES.stampDuty,
  childBenefit: ROUTES.childBenefit,
  statutorySickPay: ROUTES.statutorySickPay,
  maternityPay: ROUTES.maternityPay,
  teacherPay: ROUTES.teacherPay,
  taxFreeChildcare: ROUTES.taxFreeChildcare,
  blog: ROUTES.blog,
  about: ROUTES.about,
  'write-for-us': ROUTES.writeForUs,
  contact: ROUTES.contact,
  privacy: ROUTES.privacy,
  terms: ROUTES.terms,
};

export const categoryPath = (slug: string) => `/category/${slug}`;
export const authorPath = (slug: string) => `/authors/${slug}`;
export const postPath = (slug: string) => `/${slug}/`;
